import { BaseService } from "./BaseService";

export const LogVisorPdfService = {
  async insertar(log) {
    const respuesta = await BaseService.post("/log", log);
    return respuesta.data;
  }
};
